import { schema } from 'normalizr';
import learningLesson from './learningLesson';

const learningCourseVariantSchema = new schema.Entity('learningCourseVariants', {
  lessons: [learningLesson],
});

export default learningCourseVariantSchema;
